export const mapUserApplicationsAndRoles = (user, allRoles, allApps) => {
    const apps = {};

    user?.applicationRoles?.forEach((element) => {
        for (let i = 0; i < allApps?.length; i++) {
            let name;
            if (allApps[i]?.id === element?.applicationId) {
                name = allApps[i].displayName;
                apps[name] = {};
                apps[name].app = allApps[i];
                apps[name].roles = [];
            }
        }
    });

    user?.applicationRoles?.forEach((element) => {
        for (let i = 0; i < allRoles?.length; i++) {
            if (allRoles[i]?.id === element?.roleId) {
                let name;
                for (let i = 0; i < allApps?.length; i++) {
                    if (allApps[i]?.id === element?.applicationId) {
                        name = allApps[i].displayName?.toString();
                        break;
                    }
                }
                apps[name]?.roles.push(allRoles[i]);
            }
        }
    });

    const arrayOfObjects = Object.values(apps);
    return arrayOfObjects || [];
};
